import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { Form, Row, Col, Container } from "react-bootstrap";
import { StyledRadioInput } from "../../../Helpers/Inputs";
import BackNext from '../../Common/SubComponents/BackNext';
import SvgIcon from '@material-ui/core/SvgIcon';
import MailLetter from '../icons/MailLetter.svg';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import CalculatePolicyEffectiveDate from '../../../Helpers/Dates/Americo/PolicyDate';
import { savedQuoteEmailDrip } from '../../Common/Helpers/SavedQuoteEmailDrip';

export default function ElectronicDelivery(props) {
    const [loading, setLoading] = useState(false);
    const { register, errors, handleSubmit, setValue } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
    };

    useEffect(() => {
        register({ name: 'electronicDelivery' });
        setValue('electronicDelivery', props.formState.electronicDelivery);
    }, []);
    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
    const onSubmit = () => {
        setLoading(true);

        fetch(`${covrServicesUrl}/api/Aflac/CreateInitialCase`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
            },
            body: JSON.stringify(props.fullFormState) //test formstate being updated prior with payment info
        })
            .then(res => res.json())
            .then(json => {
                if (json.appIdentifier) {
                    let draftDate;
                    if (props.formState.draftPreference === 'Specific') {
                        draftDate = new Date(props.formState.specificStartDate);
                    }
                    else {
                        draftDate = new Date();
                    }
                    
                    props.handlePaymentComplete(json.appIdentifier, CalculatePolicyEffectiveDate(draftDate));
                    savedQuoteEmailDrip(props.fullFormState.steps.basicInfo.email);
                }
                else {
                    setLoading(false);
                }
            }).catch((e) => { setLoading(false); })
        //  props.onNext();
    };
    useEffect(() => {
        if (props.fullFormState.appIdentifier && loading) {
            props.onNext();
        }
    }, [props.fullFormState.appIdentifier]);

    return (
        <Container fluid className="electronicDelivery border-class" >
            <Form className="formPage quote-form" onSubmit={handleSubmit(onSubmit)}>
                <Row className="justify-content-center pt-3">
                    <Col className='col-div'>
                        <div className="text-center mb-2 pt-4"><SvgIcon component={MailLetter} className="small-icons" fontSize="large" color="primary" /></div>
                        <div className="text-center mb-3 form-title"><h4 className="headerTitle">Electronic Policy Delivery</h4></div>
                        <h6 className='pb-2'>I prefer to receive an electronic copy of my policy instead of a paper copy.</h6>
                        <StyledRadioInput
                            name="electronicDelivery"
                            id="electronicDelivery"
                            value={props.formState.electronicDelivery}
                            options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                            onChange={e => handleValueChange('electronicDelivery', e)}
                            errors={errors.electronicDelivery}
                            isBlankIcon={true}
                        />
                    </Col>
                </Row>
                <div className='backnext-wrapper'>
                    <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} loading={loading} />
                </div>
            </Form>
        </Container>
    );
}

ElectronicDelivery.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};


ElectronicDelivery.DefaultFormState = (prefill = false) => {
    return {
        electronicDelivery: "true"
    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/ElectronicDelivery.js